import { envConfig } from '@/configs';

function normalizeBasePath(value?: string | null): string {
  const input = String(value ?? '').trim();
  if (input === '' || input === '/') {
    return '';
  }

  const withLeadingSlash = input.startsWith('/') ? input : `/${input}`;
  return withLeadingSlash.replace(/\/+$/, '');
}

export const appBasePath = normalizeBasePath(envConfig.appBasePath);

export function stripBasePath(pathname: string): string {
  if (!appBasePath) {
    return pathname || '/';
  }
  if (pathname === appBasePath) {
    return '/';
  }
  if (pathname.startsWith(`${appBasePath}/`)) {
    return pathname.slice(appBasePath.length) || '/';
  }
  return pathname || '/';
}

export function withBasePath(path: string): string {
  if (!path) {
    return appBasePath || '/';
  }
  if (/^[a-z][a-z\d+\-.]*:\/\//i.test(path)) {
    return path;
  }
  if (!appBasePath) {
    return path;
  }
  if (path === '/') {
    return appBasePath;
  }
  if (path.startsWith(`${appBasePath}/`) || path === appBasePath) {
    return path;
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${appBasePath}${normalizedPath}`;
}

export function getCurrentPathname(): string {
  return stripBasePath(window.location.pathname);
}

export function redirectToPath(path: string) {
  window.location.href = withBasePath(path);
}
